<template>
  <div class="dlrActivity-list-item">
    <div class="dlrActivity-pic">
      <img v-if="coverUrl" :src="coverUrl" />
    </div>
    <h2 class="dlrActivity-name">{{ title }}</h2>
    <p class="dlrActivity-subname">{{ summary }}</p>
    <div class="dlrActivity-deadline">
      <span class="dlrActivity-deadline-left">报名时间：{{ endTimeStr }}</span>
      <span class="dlrActivity-deadline-right">
        <i class="dlrActivity-deadline-timeicon"></i>
        <em>{{ remainDays }}</em>
      </span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    summary: {
      type: String,
      default: ''
    },
    coverUrl: {
      type: String,
      default: ''
    },
    endTimeStr: {
      type: String,
      default: ''
    },
    remainDays: {
      type: Number,
      default: 0
    }
  }
};
</script>